// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sn-0";
export var checkoutRateBadgeLink = "_sn-1";